<template>
  <div class="pc-list" ref="list">
    <ScholarSearch @search="search" />
    <div class="pc-head">
      <div class="pc-head-handle">
        <div class="pc-head-btn">
          <button @click="deleteScholarInit">删除</button>
          <span></span>
          <button @click="addUser">添加</button>
          <span></span>
          <button @click="exportScholar">导出数据</button>
        </div>
        <p>{{ "共" + pagination_options.total + "条" }}</p>
      </div>
    </div>

    <el-table
      class="pc-list-table"
      @sort-change="changeSort"
      :data="scholarList"
    >
      <el-table-column width="100" class="singleCheckStyle" fixed="left">
        <template slot="header" slot-scope="header">
          <el-checkbox v-model="isSelectAll" @change="selectAll">{{
            "已选" + checked.length + "个"
          }}</el-checkbox>
        </template>
        <template slot-scope="scope" fixed="left">
          <el-checkbox
            v-model="scholarList[scope.$index].isSelect"
            @change="
              singleCheck(
                scope.$index,
                scope.row.isSelect,
                scope.row.id,
                scope.row
              )
            "
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column prop="image" label="头像" width="150" fixed="left">
        <template slot-scope="scope">
          <div class="eltable-img">
            <img
              v-if="scope.row.profile_image"
              :src="scope.row.profile_image"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="left"
        prop="chinese_name"
        label="姓名"
        sortable="custom"
        width="160"
      >
        <template slot-scope="scope">
          <div>
            {{
              scope.row.chinese_name
                ? scope.row.chinese_name
                : scope.row.english_name
            }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="university.chinese_name"
        label="所属院校"
        width="120"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.university">
            {{
              scope.row.university.chinese_name
                ? scope.row.university.chinese_name
                : scope.row.university.english_name
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标签" width="320">
        <template slot-scope="scope">
          <div v-if="scope.row.title">
            {{ scope.row.title.chinese_name }} <br />
            {{ scope.row.title.english_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="university.website" label="来源" width="220">
        <template slot-scope="scope">
          <div>
            {{ scope.row.source }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status" sortable="custom" width="170">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#91CC75"
            inactive-color="#C7C7C7"
            @change="changeState(scope.row)"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="createTime"
        sortable="custom"
        width="120"
      >
        <template slot-scope="scope">
          <div>{{ $dtime(scope.row.update_time).format("YYYY-MM-DD") }}</div>
        </template>
      </el-table-column>
      <el-table-column width="180">
        <template slot-scope="scope">
          <button class="btnViewDetail" @click="viewDetail(scope.row)">
            查看详情
          </button>
        </template>
      </el-table-column>
    </el-table>
    <DeleteHint
      :dialogVisible="deleteDialogVisible"
      @cancel="closeDelete"
      @delete="isDelete"
    />
    <Pagination
      v-if="scholarList.length > 0"
      :pagination="pagination_options"
      @goPage="goPage"
    />
    <!-- @handleCurrentChange="goPage"
      @goLastPage="goPage"
      @goFirstPage="goPage" -->
  </div>
</template>

<script>
import Pagination from "@/components/componentSet/Pagination";
import ScholarSearch from "./ScholarSearch";
import DeleteHint from "@/components/template/DeleteHint";
import {
  scholarSearch_Api,
  updateScholar_Api,
  deleteScholar_Api,
  outputScholar_Api
} from "@/apis/scholar.api";
export default {
  components: {
    ScholarSearch,
    Pagination,
    DeleteHint,
  },
  data() {
    return {
      loading: false,
      deleteDialogVisible: false,
      isActive: null,
      searchRules: {
        page: 1,
        page_size: 10,
        order: "-id",
      },
      pagination_options: {
        page: 1,
        total: 0,
        take: 10,
      },
      isSelectAll: false,
      scholarList: [],
      checked: [],
    };
  },
  mounted() {
    this.getScholarListByRules(this.searchRules);
  },
  methods: {
    // 获取
    getScholarListByRules(data) {
      this.loading = true;
      scholarSearch_Api(data)
        .then((res) => {
          console.log(res.data);
          this.$set(this.pagination_options, "total", res.count);
          res.data.forEach((el) => {
            el.isSelect = false;
          });
          this.scholarList = res.data;
          this.loading = false;
          this.$global.success(this, "获取成功", null);
        })
        .catch(() => {
          this.loading = false;
          this.$global.error(this, "获取失败！", null);
        });
    },
    // 全选按钮
    selectAll() {
      if (this.isSelectAll) {
        this.checked = [];
        this.checked = [];
        this.scholarList.forEach((item, i, arr) => {
          this.$set(item, "isSelect", true);
          this.checked.push(item.id);
        });
      } else {
        this.scholarList.forEach((item, i, arr) => {
          item.isSelect = false;
          this.checked = [];
        });
      }
    },
    // 单选按钮
    singleCheck(index, isSelect, rowID, row) {
      if (isSelect == false) {
        this.isSelectAll = false;
        for (let i = 0; this.checked.length > i; i++) {
          if (this.checked[i] == rowID) {
            this.checked.splice(i, 1);
            return;
          }
        }
      } else {
        this.checked.push(rowID);
        if (this.checked.length == 10) {
          this.isSelectAll = true;
        }
      }
    },
    // 排序
    changeSort(val) {
      if (val.order == "ascending") {
        this.searchRules.order = "+" + val.prop;
      }
      if (val.order == "descending") {
        this.searchRules.order = "-" + val.prop;
      }
      if (val.order == null) {
        this.searchRules.order = "-id";
      }
      this.searchRules.page = 1;
      let data = this.dealSearchRules(this.searchRules);
      this.getScholarListByRules(data);
      this.pagination_options.page = 1;
    },
    viewDetail(item) {
      let route = this.$router.resolve({
        path: "/admin/scholardetail",
        query: { id: item.id, method: "update" },
        name: "scholardetail",
        params: item,
      });
      window.open(route.href, "_blank");
    },

    // 修改状态
    changeState(row) {
      updateScholar_Api({ scholar_id: row.id, status: row.status })
        .then(() => {
          console.log("修改状态成功！");
          this.$global.success(this, "修改状态成功！", null);
        })
        .catch((res) => {
          console.log("修改状态失败！");
        });
    },
    search(formData) {
      console.log(formData);
      this.searchRules = { ...this.searchRules, page: 1, ...formData };
      let data = this.dealSearchRules(this.searchRules);
      console.log(this.searchRules);
      this.getScholarListByRules(data);
      this.pagination_options.page = 1;
    },
    dealSearchRules(formData) {
      let data = {};
      if (formData.page) {
        data.page = formData.page;
      }
      if (formData.page_size) {
        data.page_size = formData.page_size;
      }
      if (formData.order) {
        data.order = formData.order;
      }
      if (formData.wupen_flag) {
        data.wupen_flag = formData.wupen_flag;
      }
      if (formData.status) {
        data.status = parseInt(formData.status);
      }
      if (formData.name_keyword) {
        data.name_keyword = formData.name_keyword;
      }
      if (formData.tags_keywords && formData.tags_keywords.length > 0) {
        data.tags_keywords = [...formData.tags_keywords];
      }
      if (formData.university_id) {
        data.university_id = parseInt(formData.university_id);
      }
      if (formData.title_id) {
        data.title_id = parseInt(formData.title_id);
      }
      return data;
    },
    isDelete() {
      let delete_ids = { scholar_id_list: this.checked };
      console.log("delete_ids:", delete_ids);
      deleteScholar_Api(delete_ids)
        .then((res) => {
          console.log("批量删除成功！");
          this.checked = [];
          this.deleteDialogVisible = false;
          this.$global.success(this, "删除成功！");
          this.searchRules.page = 1;
          let data = this.dealSearchRules(this.searchRules);
          this.getScholarListByRules(data);
          this.pagination_options.page = 1;
        })
        .catch((err) => {
          console.log("批量删除失败！");
        });
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    // 删除学者
    deleteScholarInit() {
      if (this.checked.length > 0) {
        this.deleteDialogVisible = true;
      } else {
        this.$global.error(this, "请先勾选要删除的学者！", null);
      }
    },
    // 添加学者
    addUser() {
      let route = this.$router.resolve({
        path: "/admin/scholardetail",
        query: { method: "add" },
      });
      window.open(route.href, "_blank");
    },
    // 到出数据
    exportScholar() {
      if (this.checked.length > 0) {
        outputScholar_Api({scholar_id_list: this.checked }).then(
          (res) => {
            this.$global.downloadFile(res, "scholarList");
          }
        );
      } else {
        this.$global.error(this, "请先勾选要导出的项目！", null);
      }
    },

    goPage(pageNo) {
      this.pagination_options.page = pageNo;
      this.searchRules.page = pageNo;
      let data = this.dealSearchRules(this.searchRules);
      this.getScholarListByRules(data);
    },
  },
};
</script>



<style lang="scss" scoped>
.pc-list {
  @include table-head;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/scholar/components/ScholarTable.vue